import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "canModifyLinkText", "linkText"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFieldset from 'UIComponents/form/UIFieldset';
import { KeyTypes } from '../../constants/popover';
import { omit } from '../../utils/iterables';
//@ts-expect-error untyped module
import LinkFields from './LinkFields';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.${suffix}`;
const renderLinkTextInput = (canModifyLinkText, linkText, onUpdate) => {
  if (!canModifyLinkText) return null;
  const handleInputChange = evt => {
    onUpdate({
      linkText: evt.target.value
    });
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-bottom-1",
    label: I18n.text(i18nKey(`linkText.label`)),
    children: /*#__PURE__*/_jsx(UITextInput, {
      "data-test-id": "link-text-input",
      autoFocus: canModifyLinkText,
      value: linkText,
      onChange: handleInputChange
    })
  });
};
function LinkPopoverControlsV2(props) {
  const {
      className,
      canModifyLinkText,
      linkText
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleSubmitOnEnter = evt => {
    if (evt.key === KeyTypes.ENTER) {
      props.onSubmit();
      evt.preventDefault();
    }
  };
  return /*#__PURE__*/_jsxs(UIFieldset, {
    className: className,
    children: [renderLinkTextInput(canModifyLinkText, linkText, props.onUpdate), /*#__PURE__*/_jsx(LinkFields, Object.assign({}, rest, {
      shouldAutoFocus: !canModifyLinkText,
      onUrlKeyDown: handleSubmitOnEnter
    }))]
  });
}
const propTypes = Object.assign({}, omit(['onUrlKeyDown', 'shouldAutoFocus'], LinkFields.propTypes), {
  className: PropTypes.string,
  canModifyLinkText: PropTypes.bool,
  linkText: PropTypes.string
});
LinkPopoverControlsV2.propTypes = propTypes;
LinkPopoverControlsV2.displayName = 'LinkPopoverControlsV2';
export default LinkPopoverControlsV2;